/* Sanador landing - shared behavior. Loaded per-section; runs once. */
(function(){ if(window.__SAN_INIT) return; window.__SAN_INIT = 1;
var LP_VIDEO = window.LP_VIDEO || '';

/* Video play — delegated so it works no matter when the script loads
   relative to the hero markup (per-section script_tag ordering). */
(function(){
  document.addEventListener('click', function(e){
    var playUi = e.target.closest('#playUi, .video-frame, .play-ui, .play-btn');
    if(!playUi) return;
    var frame = document.getElementById('videoFrame') || (playUi.closest && playUi.closest('.video-frame'));
    if(!frame) return;
    if(frame.querySelector('video')) return;          // already playing
    var u = window.LP_VIDEO || '';
    if(!u) return;                                     // no source set -> leave poster
    e.preventDefault();
    var poster = document.getElementById('heroPoster') || frame.querySelector('.poster');
    var ui = document.getElementById('playUi') || frame.querySelector('.play-ui');
    var v = document.createElement('video');
    v.src = u; v.controls = true; v.autoplay = true; v.playsInline = true; v.setAttribute('playsinline','');
    v.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;background:#000;z-index:4';
    frame.appendChild(v);
    if(ui) ui.style.display = 'none';
    if(poster) poster.style.display = 'none';
    var p = v.play(); if(p && p.catch) p.catch(function(){});
  }, false);
})();

/* ============================================================
   THE HOLISTIC HEALER EXPERT BOOK - landing page interactions
   ------------------------------------------------------------
   Flow: any "buy" button -> custom checkout drawer (upsells +
   reviews + countdown) -> "Complete secure order" hands off to
   the real Shopify checkout with the chosen items in the cart.

   SET ONCE in the HTML (script just above app.js):
     window.LP_STORE       = "https://your-store.myshopify.com";
     window.LP_VARIANT_ID  = "1234567890";   // the book's variant id
   Optional per-upsell: put each add-on's variant id in the
   data-variant="" attribute on its .bump element.
   ============================================================ */
(function(){
  'use strict';
  const $  = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => [...r.querySelectorAll(s)];

  /* Defer ALL setup until the full page is parsed. This script is injected
     per-section and runs once on its FIRST occurrence (the ticker, at the
     top of the page) — long before the hero countdown and footer cart
     drawer exist. Querying them at that point returned null, which is why
     the buttons, cart and timer were dead. Booting on DOMContentLoaded
     guarantees every element exists before we wire it up. */
  function boot(){
  const STORE       = (window.LP_STORE || '').trim().replace(/\/+$/,'');
  const PRODUCTS    = window.LP_PRODUCTS || {};
  const VARIANT_ID  = (PRODUCTS.book || window.LP_VARIANT_ID || '').trim();
  const CHECKOUT_URL= (window.LP_CHECKOUT_URL || '').trim();
  const BASE_PRICE  = 9.99;
  const COMPARE_AT  = 97;

  /* map each upsell's data-key -> its variant id from LP_PRODUCTS */
  function upsellVariant(bump){
    const explicit = (bump.dataset.variant || '').trim();
    if(explicit) return explicit;
    const key = (bump.dataset.key || '').trim();
    return (PRODUCTS[key] || '').trim();
  }

  /* ---------- reading progress + sticky chrome ---------- */
  const progress  = $('#progress');
  const topbar    = $('#topbar');
  const stickyCta = $('#stickyCta');
  const hero      = $('.hero');

  function onScroll(){
    const h = document.documentElement;
    const max = h.scrollHeight - h.clientHeight;
    const pct = max > 0 ? (h.scrollTop || document.body.scrollTop) / max * 100 : 0;
    if(progress) progress.style.width = pct + '%';
    const past = (window.scrollY || h.scrollTop) > (hero ? hero.offsetHeight - 80 : 600);
    if(topbar) topbar.classList.toggle('show', past);
    const final = $('.final');
    const nearFinal = final && (window.scrollY + window.innerHeight) > (final.offsetTop + 120);
    if(stickyCta) stickyCta.classList.toggle('show', past && !nearFinal);
  }
  window.addEventListener('scroll', onScroll, { passive:true });
  window.addEventListener('resize', onScroll);
  onScroll();

  /* ---------- FAQ accordion ---------- */
  $$('#faq .qa').forEach(qa => {
    const btn = $('button', qa);
    const ans = $('.ans', qa);
    btn.addEventListener('click', () => {
      const open = qa.classList.contains('open');
      $$('#faq .qa').forEach(o => { o.classList.remove('open'); $('.ans', o).style.maxHeight = null; });
      if(!open){ qa.classList.add('open'); ans.style.maxHeight = ans.scrollHeight + 'px'; }
    });
  });

  /* ---------- countdown (10-minute loop: 10:00 -> 0:00 -> restarts) ---------- */
  const groups = $$('#countdown, #countdown2').map(c => $$('b', c));
  const cartCd = $('#cartCd');
  const DURATION = 10*60*1000;
  let deadline = Date.now() + DURATION;            // fresh 10:00 on every page load
  const pad = n => String(n).padStart(2,'0');
  function tickClock(){
    let ms = deadline - Date.now();
    if(ms <= 0){ deadline = Date.now() + DURATION; ms = DURATION; }   // hit zero -> restart at 10:00
    let s = Math.floor(ms/1000);
    const hh = Math.floor(s/3600); s%=3600;
    const mm = Math.floor(s/60); const ss = s%60;
    groups.forEach(cells => {
      if(cells[0]) cells[0].textContent = pad(hh);
      if(cells[1]) cells[1].textContent = pad(mm);
      if(cells[2]) cells[2].textContent = pad(ss);
    });
    if(cartCd) cartCd.textContent = pad(mm + hh*60) + ':' + pad(ss);
  }
  tickClock(); setInterval(tickClock, 1000);

  /* ============================================================
     CUSTOM CHECKOUT DRAWER
  ============================================================ */
  const cartOverlay = $('#cartOverlay');
  const cartDrawer  = $('#cartDrawer');

  function openCart(){
    if(!cartDrawer) return;
    cartOverlay.classList.add('show');
    cartDrawer.classList.add('show');
    cartOverlay.style.visibility = 'visible';
    cartOverlay.style.opacity = '1';
    cartDrawer.style.transform = 'translateX(0)';
    document.body.style.overflow = 'hidden';
    updateTotals();
  }
  function closeCart(){
    if(!cartDrawer) return;
    cartOverlay.classList.remove('show');
    cartDrawer.classList.remove('show');
    cartOverlay.style.opacity = '0';
    cartDrawer.style.transform = 'translateX(100%)';
    setTimeout(() => { cartOverlay.style.visibility = 'hidden'; }, 320);
    document.body.style.overflow = '';
  }

  function money(n){ return '$' + (Math.round(n*100)/100).toFixed(2); }

  function updateTotals(){
    let sub = BASE_PRICE;
    $$('.bump.on').forEach(b => sub += parseFloat(b.dataset.price || 0));
    const save = Math.max(0, Math.round(COMPARE_AT - BASE_PRICE));
    const subEl = $('#cartSub'), totEl = $('#cartTotal'), saveEl = $('#cartSave');
    if(subEl) subEl.textContent = money(sub);
    if(totEl) totEl.textContent = money(sub);
    if(saveEl) saveEl.textContent = '−$' + save;
  }

  /* ---------- on Shopify: add to real cart + open native side drawer ---------- */
  const ON_SHOPIFY = typeof window.Shopify !== 'undefined' || !!document.querySelector('cart-drawer, #cart-icon-bubble, a[href$="/cart"]');

  function openNativeDrawer(){
    const dd = document.querySelector('cart-drawer');
    if(dd){
      if(typeof dd.open === 'function'){ dd.open(); return; }
      dd.classList.add('active','animate','is-open','open');
      dd.setAttribute('open','');
    }
    document.documentElement.classList.add('cart-drawer-open');
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles:true }));
    const icon = document.querySelector('#cart-icon-bubble, a[href="/cart"], a[href$="/cart"], .header__icon--cart, [aria-label*="cart" i]');
    if(icon){ icon.click(); return; }
    if(!dd) window.location.href = '/cart';
  }

  async function addToShopifyCart(){
    if(!(VARIANT_ID && /^\d+$/.test(VARIANT_ID))){
      alert('This buy button needs your product VARIANT ID.\n\nPaste it into LP_PRODUCTS.book at the top of the section file.');
      return;
    }
    const items = [{ id: Number(VARIANT_ID), quantity: 1 }];
    try{
      await fetch('/cart/add.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ items })
      });
    }catch(e){ /* still try to open the cart */ }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
    openNativeDrawer();
  }

  /* upsell tick / untick (preview drawer only) */
  $$('.bump').forEach(b => {
    b.addEventListener('click', () => { b.classList.toggle('on'); updateTotals(); });
  });

  /* every buy button -> ALWAYS show our custom side-cart (with bundles).
     We never open Horizon's native drawer (it has no bundle bumps).
     "Completar pedido seguro" then builds a /cart permalink that carries
     the book + every ticked bump straight into Shopify checkout. */
  document.addEventListener('click', e => {
    const buy = e.target.closest('.js-buy');
    if(!buy) return;
    e.preventDefault();
    openCart();                          // custom drawer + bundle bumps
  });

  /* close: X button, overlay click, ESC  (the fix) */
  $$('[data-close-cart]').forEach(b => b.addEventListener('click', closeCart));
  if(cartOverlay) cartOverlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if(e.key === 'Escape') closeCart(); });

  /* complete order -> Shopify checkout with chosen items */
  async function goToShopify(){
    // explicit full URL wins -- but ONLY if it's a real checkout URL.
    // A product/collection link here would send the customer to the catalog
    // instead of checkout, so we ignore those and fall through to add+go.
    if(CHECKOUT_URL
       && !/PASTE|REPLACE/i.test(CHECKOUT_URL)
       && !/\/products?\/|\/collections?\/|shopify:\/\/(products|collections)/i.test(CHECKOUT_URL)){
      window.location.href = CHECKOUT_URL; return;
    }

    // collect the book + every ticked bump that has a numeric variant id
    const items = [];
    if(VARIANT_ID && /^\d+$/.test(VARIANT_ID)) items.push({ id: Number(VARIANT_ID), quantity: 1 });
    $$('.bump.on').forEach(b => {
      const v = upsellVariant(b);
      if(/^\d+$/.test(v)) items.push({ id: Number(v), quantity: 1 });
    });

    // add to the REAL Shopify cart, then jump STRAIGHT to the checkout page
    // (where the customer fills in their details) -- never the cart or catalog.
    if(items.length){
      try{
        await fetch('/cart/clear.js', { method:'POST', headers:{ 'Content-Type':'application/json' } });
        await fetch('/cart/add.js', {
          method:'POST',
          headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
          body: JSON.stringify({ items })
        });
        window.location.href = '/checkout';
      }catch(e){
        // network blocked -> fall back to a cart permalink (still reaches checkout)
        const parts = items.map(it => it.id + ':' + it.quantity);
        window.location.href = (STORE || '') + '/cart/' + parts.join(',');
      }
      return;
    }
    // no variant yet -> send to store so any product can be added
    if(STORE){ window.location.href = STORE; return; }
    alert('Checkout not set up yet.\n\nPaste your product VARIANT ID into:\n  window.LP_VARIANT_ID = "...";');
  }
  const checkoutBtn = $('.js-checkout');
  if(checkoutBtn){
    checkoutBtn.addEventListener('click', () => {
      checkoutBtn.style.opacity = '.75';
      checkoutBtn.innerHTML = 'Redirecting to secure checkout…';
      setTimeout(goToShopify, 350);
    });
  }

  /* ============================================================
     SOCIAL-PROOF TOASTS
  ============================================================ */
  const wrap = $('#toastWrap');
  if(wrap){
    const ES = (window.LP_LANG === 'es');
    const people = ES ? [
      ['María', 'México'], ['Carmen', 'España'], ['Lucía', 'Colombia'],
      ['Sofía', 'Argentina'], ['Elena', 'Texas'], ['Rosa', 'Florida'],
      ['Patricia', 'California'], ['Ana', 'Chile'], ['Marta', 'Perú'],
      ['Isabel', 'Nueva York'], ['Teresa', 'Ecuador'], ['Gloria', 'Arizona']
    ] : [
      ['Maria', 'Ohio'], ['Janet', 'Pennsylvania'], ['Debra', 'Indiana'],
      ['Priya', 'Ontario'], ['Susan', 'Iowa'], ['Carol', 'Kentucky'],
      ['Angela', 'Wisconsin'], ['Rachel', 'Michigan'], ['Linda', 'Missouri'],
      ['Karen', 'Tennessee'], ['Joan', 'Kansas'], ['Theresa', 'Illinois']
    ];
    const T = ES ? {
      sep: ' de ',
      got: 'acaba de obtener El Libro Experto del Sanador Holístico',
      ago: m => 'hace ' + m + ' min'
    } : {
      sep: ' from ',
      got: 'just got The Holistic Healer Expert Book',
      ago: m => m + ' min ago'
    };
    const starsSvg = '<span class="stars">' +
      Array(5).fill('<svg viewBox="0 0 24 24"><use href="#i-star"/></svg>').join('') + '</span>';
    let idx = Math.floor(Math.random()*people.length);
    function showToast(){
      const [name, loc] = people[idx % people.length]; idx++;
      const mins = 2 + Math.floor(Math.random()*42);
      const el = document.createElement('div');
      el.className = 'toast';
      el.innerHTML =
        '<div class="t-av">'+name[0]+'</div>'+
        '<div><b>'+name+T.sep+loc+'</b>'+
        '<p>'+T.got+'</p>'+
        '<div class="t-time">'+starsSvg+' · '+T.ago(mins)+'</div></div>';
      wrap.appendChild(el);
      requestAnimationFrame(() => el.classList.add('show'));
      setTimeout(() => { el.classList.remove('show'); setTimeout(() => el.remove(), 600); }, 4800);
      scheduleToast();
    }
    function scheduleToast(){ setTimeout(showToast, 9000 + Math.random()*7000); }
    setTimeout(showToast, 4200);
  }
  } /* ---- end boot() ---- */

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

})();

/* ============================================================
   Botanical decor — dandelions, drifting wisps, green flow,
   the golden healing figure, ginger & lemon line-art.
   All geometric line-art, sage/gold, kept subtle and blended.
   ============================================================ */
(function(){
  'use strict';

  function seedHead(size){
    const cx=size/2, cy=size/2, R=size*0.42, n=54;
    let s='';
    for(let i=0;i<n;i++){
      const a=(i/n)*Math.PI*2 + (Math.random()-.5)*0.05;
      const len=R*(0.78+Math.random()*0.22);
      const x2=(cx+Math.cos(a)*len).toFixed(1), y2=(cy+Math.sin(a)*len).toFixed(1);
      s+=`<line x1="${cx}" y1="${cy}" x2="${x2}" y2="${y2}"/>`;
      s+=`<circle cx="${x2}" cy="${y2}" r="${(size*0.011).toFixed(1)}" fill="currentColor" stroke="none"/>`;
    }
    for(let k=0;k<3;k++){
      const a=-Math.PI*0.15 - k*0.18, d=R*(1.1+k*0.18);
      const x=(cx+Math.cos(a)*d).toFixed(1), y=(cy+Math.sin(a)*d).toFixed(1);
      s+=`<circle cx="${x}" cy="${y}" r="${(size*0.012).toFixed(1)}" fill="currentColor" stroke="none"/>`;
      s+=`<line x1="${x}" y1="${y}" x2="${(+x+size*0.05).toFixed(1)}" y2="${(+y-size*0.04).toFixed(1)}"/>`;
    }
    return `<svg width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" fill="none" stroke="currentColor" stroke-width="${(size*0.0035).toFixed(2)}" stroke-linecap="round" aria-hidden="true">${s}<circle cx="${cx}" cy="${cy}" r="${(size*0.018).toFixed(1)}" fill="currentColor" stroke="none"/></svg>`;
  }

  function wisp(sz){
    const cx=sz/2, top=sz*0.16, n=9; let s='';
    for(let i=0;i<n;i++){
      const a=(-Math.PI/2)+(i-(n-1)/2)*(Math.PI/n)*0.95;
      const x2=(cx+Math.cos(a)*sz*0.34).toFixed(1), y2=(top+Math.sin(a)*sz*0.34).toFixed(1);
      s+=`<line x1="${cx}" y1="${top}" x2="${x2}" y2="${y2}"/>`;
      s+=`<circle cx="${x2}" cy="${y2}" r="${(sz*0.02).toFixed(1)}" fill="currentColor" stroke="none"/>`;
    }
    s+=`<path d="M${cx} ${top} Q ${cx+sz*0.07} ${sz*0.55} ${cx} ${sz*0.82}"/>`;
    s+=`<ellipse cx="${cx}" cy="${(sz*0.86).toFixed(1)}" rx="${(sz*0.03).toFixed(1)}" ry="${(sz*0.055).toFixed(1)}" fill="currentColor" stroke="none"/>`;
    return `<svg width="${sz}" height="${sz}" viewBox="0 0 ${sz} ${sz}" fill="none" stroke="currentColor" stroke-width="${(sz*0.018).toFixed(2)}" stroke-linecap="round" aria-hidden="true">${s}</svg>`;
  }

  function lemon(s){
    return `<svg width="${s}" height="${s}" viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <ellipse cx="50" cy="58" rx="30" ry="24"/>
      <path d="M50 34c-3-5-2-10 0-13"/>
      <path d="M52 23c9-4 18 1 18 1s-9 8-18-1z"/>
      <path d="M28 50c14 12 30 12 44 0" opacity=".45"/>
    </svg>`;
  }

  function ginger(s){
    return `<svg width="${s}" height="${(s*0.83)|0}" viewBox="0 0 120 100" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M20 62q-6-16 10-20 8-2 12 5 3-12 16-10 10 2 10 13 10-6 18 2 7 7 0 16 9 4 4 15-4 9-16 6-3 10-15 8-12-2-12-13-12 0-12-12-3-8 5-12z"/>
      <path d="M42 54q6 6 4 13M70 52q6 6 2 13M58 42q4 8 0 15" opacity=".4"/>
      <path d="M28 48q-8-6-13-2M98 62q8-2 11 3" opacity=".45"/>
    </svg>`;
  }

  function flowWave(){
    return `<svg viewBox="0 0 1200 500" preserveAspectRatio="none" width="100%" height="100%" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <path d="M-40 180 C 280 90, 520 320, 860 210 S 1300 170 1300 170" opacity=".9"/>
      <path d="M-40 260 C 340 170, 540 400, 900 270 S 1300 250 1300 250" opacity=".6"/>
      <path d="M-40 340 C 300 280, 560 470, 960 350 S 1300 330 1300 330" opacity=".4"/>
    </svg>`;
  }
  const emblemSVG = `<svg viewBox="0 0 100 100" width="100%" height="100%" aria-hidden="true"><use href="#i-emblem"/></svg>`;

  function init(){
    // drifting wisps (fixed sky)
    const sky=document.createElement('div'); sky.className='botanical-sky';
    for(let i=0;i<8;i++){
      const el=document.createElement('div'); el.className='wisp';
      const sz=18+Math.random()*26;
      el.style.top=(Math.random()*90)+'vh';
      el.style.animationDuration=(34+Math.random()*40)+'s';
      el.style.animationDelay=(-Math.random()*60)+'s';
      el.style.opacity=(0.28+Math.random()*0.22).toFixed(2);
      el.innerHTML=wisp(sz);
      sky.appendChild(el);
    }
    document.body.appendChild(sky);

    const add=(sel, cls, css, html)=>{
      const host=document.querySelector(sel); if(!host) return;
      const d=document.createElement('div'); d.className=cls;
      Object.assign(d.style, css); d.innerHTML=html;
      host.appendChild(d);
    };

    // ---- green flow + golden healing figure (page backdrop) ----
    add('.hero', 'bg-flow', {left:'0', right:'0', bottom:'-20px', width:'100%', height:'440px', opacity:'.12'}, flowWave());
    add('.hero', 'bg-emblem', {top:'150px', right:'-50px', width:'320px', height:'320px', opacity:'.10'}, emblemSVG);
    add('.emblem-band', 'bg-flow', {left:'0', right:'0', top:'0', width:'100%', height:'100%', opacity:'.12'}, flowWave());
    add('.final', 'bg-emblem', {bottom:'20px', left:'3%', width:'220px', height:'220px', opacity:'.14'}, emblemSVG);
    add('.final', 'bg-flow', {left:'0', right:'0', top:'0', width:'100%', height:'100%', opacity:'.08', color:'var(--gold)'}, flowWave());

    // ---- dandelions ----
    add('.hero', 'dandy', {top:'90px', left:'-40px', transform:'rotate(-12deg)', opacity:'.4', color:'var(--sage)'}, seedHead(200));
    add('.hero', 'dandy', {top:'330px', right:'30px', transform:'rotate(20deg)', opacity:'.3', color:'var(--sage)'}, seedHead(140));
    add('.recipe-section', 'dandy', {top:'40px', right:'-20px', transform:'rotate(-8deg)', opacity:'.26', color:'var(--sage)'}, seedHead(170));
    add('.story-sec', 'dandy', {top:'30px', left:'1%', transform:'rotate(14deg)', opacity:'.3', color:'var(--sage)'}, seedHead(150));

    // ---- ginger + lemon: middle of the page ----
    add('.recipe-section', 'botanical', {top:'90px', left:'-26px', width:'160px', height:'130px', transform:'rotate(-8deg)', opacity:'.14', color:'var(--sage)'}, ginger(160));
    add('.story-sec', 'botanical', {bottom:'-6px', right:'2%', width:'150px', height:'120px', transform:'rotate(6deg)', opacity:'.16', color:'var(--sage)'}, ginger(150));

    // ---- ginger: near the bottom ----
    add('[data-screen-label="FAQ"]', 'botanical', {bottom:'24px', left:'1%', width:'150px', height:'120px', transform:'rotate(-7deg)', opacity:'.12', color:'var(--sage)'}, ginger(150));
    add('.final', 'botanical', {bottom:'30px', right:'4%', width:'140px', height:'112px', transform:'rotate(10deg)', opacity:'.16', color:'var(--gold)'}, ginger(140));
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

})();
